import React from "react";

let Heading = () => {
  return (
    <div className="heading">
      <img
        className="logo"
        src="https://i.pinimg.com/474x/97/c0/a6/97c0a6e7b8659040034e248514e86e88.jpg"
        alt="5 star hotel black and white png"
      />
      <header className="App-header">CYF Hotel</header>
    </div>
  );
};

export default Heading;
